import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { bills } from "data/actions";
import ImageField from "components/Form/ImageField";
import Price from "components/Formaters/Price";
import Row from "components/Form/Row";
import Field from "components/Form/Field";
import DateField from "components/Form/DateField";
import FlatButton from "material-ui/FlatButton";
import Dialog from "material-ui/Dialog";

class BillFormDialog extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  state = { open: false };

  componentDidMount() {}

  openDialog = e => {
    if (e) {
      e.preventDefault();
    }
    var state = { ...this.state, open: true };
    this.setState(state);
  };

  closeDialog = event => {
    var state = { ...this.state, open: false };
    this.setState(state);
  };

  saveBill = event => {
    var data = _.map(this.refs, (r, i) => {
      console.log(i, r.state.value);
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(...data);
    merged.pdf = this.refs.pdf.state.url || "";

    console.log("bill", merged);
    this.props.actions.addBill(this.props.accountid, merged, this.closeDialog);
  };

  render() {
    const actions = [
      <FlatButton
        label="Avbryt"
        primary={true}
        onTouchTap={this.closeDialog}
      />,
      <FlatButton label="Spara" primary={true} onTouchTap={this.saveBill} />
    ];
    return (
      <Dialog
        title="Skapa faktura"
        actions={actions}
        modal={false}
        open={this.state.open}
      >
        <Row>
          <Field floatingLabelText="Beskrivning" ref="description" value="" />
        </Row>
        <Row>
          <Field floatingLabelText="Belopp" ref="amount" value="" />
        </Row>
        <Row>
          <Field floatingLabelText="OCR" ref="ocr" value="" />
        </Row>
        <Row>
          <DateField hintText="Förfallodatum" ref="expirydate" value={0} />
        </Row>
        <Row>
          <ImageField ref="pdf" label="PDF faktura" />
        </Row>
      </Dialog>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}
const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...bills }, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatch, null, { withRef: true })(
  BillFormDialog
);



// WEBPACK FOOTER //
// ./src/components/Balance/BillFormDialog.jsx